module.exports = __webpack_public_path__ + "img/doc.f642dd23.png";